export default "__VITE_ASSET__DBhpIdZD__"